import { NavLink, useNavigate } from "react-router-dom";
import {
	LayoutDashboard,
	Package,
	MessageSquare,
	Building2,
	BarChart3,
	Settings,
} from "lucide-react";
import { useV2Auth } from "../V2App";

const ICON_PROPS = { size: 18, strokeWidth: 2 };

const navItems = [
	{ path: "/dashboard", label: "Dashboard", Icon: LayoutDashboard },
	{ path: "/workspace", label: "Workspace", Icon: Package },
	{ path: "/providers", label: "Providers", Icon: Building2 },
	{ path: "/analytics", label: "Analytics", Icon: BarChart3 },
	{ path: "/settings", label: "Settings", Icon: Settings },
];

export default function V2Sidebar() {
	const { user, logout } = useV2Auth();
	const navigate = useNavigate();

	const handleLogout = () => {
		logout();
		navigate("/login");
	};

	return (
		<aside className="v2-sidebar">
			<div className="v2-sidebar-brand">
				<NavLink to="/dashboard" className="v2-sidebar-logo">
					<img src="/brand/favicon.png" alt="Marteu" className="v2-logo-icon" />
					<img
						src="/brand/logotype-bone.png"
						alt="MARTEU"
						className="v2-logo-text-img"
					/>
				</NavLink>
			</div>

			<nav className="v2-sidebar-nav">
				{navItems.map(({ path, label, Icon }) => (
					<NavLink
						key={path}
						to={path}
						className={({ isActive }) =>
							`v2-sidebar-link${isActive ? " v2-sidebar-link--active" : ""}`
						}
					>
						<span className="v2-sidebar-link-icon">
							<Icon {...ICON_PROPS} />
						</span>
						<span className="v2-sidebar-link-label">{label}</span>
					</NavLink>
				))}
			</nav>

			<div className="v2-sidebar-footer">
				<div className="v2-sidebar-user">
					<div className="v2-sidebar-avatar">{user?.avatarInitials || "U"}</div>
					<div className="v2-sidebar-user-info">
						<span className="v2-sidebar-user-name">{user?.name || "User"}</span>
						<span className="v2-sidebar-user-company">
							{user?.company || "Company"}
						</span>
					</div>
				</div>
				<button
					className="v2-sidebar-logout"
					onClick={handleLogout}
					title="Logout"
				>
					↩
				</button>
			</div>
		</aside>
	);
}
